// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para el sidebar */
.main-sidebar {
    position: fixed;
    height: 100vh;
    overflow-y: auto;
    width: 250px;
    z-index: 1000;
}

/* Scroll personalizado opcional */
.main-sidebar::-webkit-scrollbar {
    width: 6px;
}

.main-sidebar::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}

.main-sidebar::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 3px;
}

/* Ajuste visual para dispositivos pequeños */
@media (max-width: 768px) {
    .main-sidebar {
        width: 220px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Css/Sidebar/sidebar.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA,kCAAkC;AAClC;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* Estilos para el sidebar */\r\n.main-sidebar {\r\n    position: fixed;\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    width: 250px;\r\n    z-index: 1000;\r\n}\r\n\r\n/* Scroll personalizado opcional */\r\n.main-sidebar::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.main-sidebar::-webkit-scrollbar-track {\r\n    background-color: #f1f1f1;\r\n}\r\n\r\n.main-sidebar::-webkit-scrollbar-thumb {\r\n    background-color: #888;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* Ajuste visual para dispositivos pequeños */\r\n@media (max-width: 768px) {\r\n    .main-sidebar {\r\n        width: 220px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
